import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { StorageKeys } from "src/app/enums";
import { AppState } from "./app.interfaces";
import { withDevtools } from "@angular-architects/ngrx-toolkit";

const initialState: AppState = {
  origin: "",
};

export const AppStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods(store => ({
    setOrigin(origin: string): void {
      patchState(store, { origin });
    },
  })),
  withDevtools(StorageKeys.AppStore),
);
